module.exports = __webpack_public_path__ + "img/L0.5879e007.jpg";